<template>
  <div
    v-if="loading"
    class="d-flex-center"
  >
    <template v-if="!hideLoader">
      <fluency-loader />
      <small v-if="statusLog && statusLog.length > 0">
        {{ statusLog[statusLog.length - 1] }}
      </small>
      <small v-else>Starting Processes</small>
    </template>
  </div>
</template>

<script>
import FluencyLoader from 'core-ui/components/common/fluencyLoader.vue'

export default {
  name: 'asyncFetcher',
  components: { FluencyLoader },
  props: {
    timeout: {
      // 'Time in milliseconds'
      type: Number,
      default: 1000
    },
    timesToAttempt: {
      // Number of times to try before failing
      type: Number,
      default: 120
    },
    hideLoader: {
      type: Boolean,
      default: false
    },
    file: {
      type: Boolean,
      default: false
    },
    emailMethod: {
      type: Function
    },
    emailSeconds: {
      type: Number,
      default: 30
    },
    sendRawObjects: {
      type: Boolean,
      default: false
    }
  },
  expose: ['asyncFetch', 'killAsyncFetch'],
  data () {
    return {
      statusLog: [],
      loading: false,
      fetchStartEvent: null
    }
  },
  computed: {
    options () {
      return {
        sendRawObjects: this.sendRawObjects,
        intervalTime: this.timeout,
        maxAttempts: this.timesToAttempt,
        secondsBeforeEmail: this.emailSeconds,
        file: this.file,
        emailEndpoint: this.emailMethod
      }
    }
  },
  beforeUnmount () {
    if (this.fetchStartEvent?.kill) {
      this.fetchStartEvent.kill()
    }
  },
  methods: {
    onStatus (data) {
      this.statusLog = data
      this.$emit('status', data)
    },
    onStart (data) {
      this.loading = true
      this.fetchStartEvent = data
      this.$emit('start', data)
    },
    onEnd () {
      this.loading = false
      this.$emit('end')
    },
    onFail (data) {
      this.$emit('fail', data)
    },
    onKill (data) {
      this.$emit('kill', data)
    },
    onSuccess (data) {
      this.$emit('success', data)
    },
    asyncFetch (method, args, callback) {
      const callbacks = {
        onStatus: this.onStatus,
        onSuccess: callback || this.onSuccess,
        onFail: this.onFail,
        onStart: this.onStart,
        onEnd: this.onEnd,
        onKill: this.onKill
      }
      this.$asyncFetch(method, args, this.options, callbacks)
    },
    killAsyncFetch () {
      if (this.fetchStartEvent?.kill) {
        this.fetchStartEvent.kill()
      }
    }
  },
  render: function (createElement) {
    return createElement('div', { class: 'd-none' })
  }
}
</script>
